import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Container } from '../../../../../../../../assets/elements';
import TypeCollection from './Collection';
import TypeDrop from './TypeDropdown';
import device from '../../../../../../../utils/device';

const CollectionDetails = (props: any) => {
  const { type } = useSelector<any, any>((state) => state.order.item);

  return (
    <Wrapper>
      {!type || type === 'collection' ? (
        <TypeCollection {...props} />
      ) : (
        <TypeDrop {...props} />
      )}
    </Wrapper>
  );
};
const Wrapper = styled(Container)`
  background: #ffffff;
  border-radius: 8px;
  && {
    padding: 15px;
    @media ${device.tablet} {
      padding: 30px;
    }
  }
  height: auto;
  margin: 40px 0;
`;

export default CollectionDetails;
